// External services the frontend talks to, set at build time (build-pipeline.yaml, package.json esbuild:build,
// server.js). Every name must be defined there: esbuild replaces `process.env.X`, and an undefined one throws in
// the browser. The defaults are the GoodDev deployment's values.

/** Identity login page (sign-in, /Goto, /RefreshToken, /Logout). */
export const HELLO_URL = process.env.HELLO_URL || 'https://hello.gooddev.app';
/** Identity API (POST /jwt/exchange). */
export const IDENTITY_URL = process.env.IDENTITY_URL || 'https://identity.gooddev.app';
/** Collab socket host (no scheme). */
export const COLLAB_HOST = process.env.COLLAB_HOST || 'collab.gooddev.app';
/** song-io socket host (no scheme). Still the legacy host: song-io isn't on the GoodDev cluster yet. */
export const IO_HOST = process.env.IO_HOST || 'io.songtek.net';
/** Legacy song API. Still the legacy host: it isn't on the GoodDev cluster yet (migration plan item 2). */
export const SONG_API_URL = process.env.SONG_API_URL || 'https://api.songtek.net';
